import CryptoJS from 'crypto-js';

const decryptToken = (encryptedToken: string, key: string) => {
  try {
    const urlDecoded = decodeURIComponent(encryptedToken);

    const decryptedBytes = CryptoJS.AES.decrypt(urlDecoded, key);

    const decryptedToken = decryptedBytes.toString(CryptoJS.enc.Utf8);

    return decryptedToken;
  } catch (error) {
    console.error('Error decrypting token:', error);
    return null;
  }
};

export async function decryptDataClient(
  payload: string,
  secret: string = process.env.NEXT_PUBLIC_GOKWIK_USER_TOKEN_KEY || ''
): Promise<{ zl_uid: string; secret: string; user_id?: number }> {
  // 1. Derive 32-byte key using SHA-256
  const keyHash = await crypto.subtle.digest(
    'SHA-256',
    new TextEncoder().encode(secret)
  );
  const cryptoKey = await crypto.subtle.importKey(
    'raw',
    keyHash,
    'AES-GCM',
    false,
    ['decrypt']
  );

  // 2. Decode Base64 string
  let b64 = payload.trim().replace(/-/g, '+').replace(/_/g, '/');
  while (b64.length % 4) b64 += '=';

  const binary = atob(b64);
  const data = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) data[i] = binary.charCodeAt(i);

  if (data.length < 28) throw new Error('Invalid encrypted payload: too short');

  // 3. Extract IV (12 bytes), Tag (16 bytes), Ciphertext
  const iv = data.slice(0, 12);
  const tag = data.slice(12, 28);
  const encrypted = data.slice(28);

  // Web Crypto expects ciphertext + tag concatenated
  const combined = new Uint8Array(encrypted.length + tag.length);
  combined.set(encrypted, 0);
  combined.set(tag, encrypted.length);

  // 4. Decrypt
  const decrypted = await crypto.subtle.decrypt(
    { name: 'AES-GCM', iv },
    cryptoKey,
    combined
  );
  return JSON.parse(new TextDecoder().decode(decrypted));
}

export default decryptToken;
